import { render } from "./TerminosYCondiciones.vue?vue&type=template&id=242b5f59&scoped=true"
import script from "./TerminosYCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosYCondiciones.vue?vue&type=script&lang=js"

import "./TerminosYCondiciones.vue?vue&type=style&index=0&id=242b5f59&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242b5f59"]])

export default __exports__